import styled from 'styled-components';
import {
  Notification,
  NotificationGroup,
} from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectShowToast, selectToastDelay } from 'app/error/slice/selectors';
import { useErrorHandlingSlice } from 'app/error/slice';
import errorIcon from '../Toast/assets/CrossRedIcon.svg';
import successIcon from '../Toast/assets/GreenTickIcon.svg';
import closeIcon from '../Toast/assets/BlackCrossIcon.svg';
import { CommonMessages } from 'locales/CommonMessage/messages';
import { useTranslation } from 'react-i18next';
export const Toast = () => {
  const showToast = useSelector(selectShowToast);
  const toastDelay = useSelector(selectToastDelay);
  const selectedShowToast = useSelector(selectShowToast);
  const dispatch = useDispatch();
  const { actions } = useErrorHandlingSlice();
  const { t } = useTranslation();
  React.useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        actions.dispatchToast({ errorTxt: '', show: false, errorType: 'none' }),
      );
      dispatch(actions.setToastDelay(undefined));
    }, toastDelay ?? 2000);
    return () => {
      clearTimeout(timer);
    };
  }, [showToast]);

  return (
    <>
      {showToast?.show && (
        <Wrapper
          className={`change-widthparent ${toastDelay ? 'change-width' : ''}`}
        >
          <NotificationGroup
            style={{
              bottom: 0,
              right: 0,
              zIndex: 10010,
            }}
            className={`change-width-toast ${toastDelay ? 'change-width' : ''}`}
          >
            <Fade>
              <Notification
                type={{ style: selectedShowToast?.errorType }}
                closable={true}
                onClose={() =>
                  dispatch(
                    actions.dispatchToast({
                      errorTxt: '',
                      show: false,
                      errorType: 'none',
                    }),
                  )
                }
              >
                <ContentWarpper data-testid="error-toast">
                  {selectedShowToast?.errorType === 'error' ? (
                    <img src={errorIcon} alt="Error Icon" />
                  ) : selectedShowToast?.errorType === 'success' ? (
                    <img src={successIcon} alt="Success Icon" />
                  ) : null}
                  <div className="title-wrapper">
                    <span className="title">
                      {selectedShowToast?.errorType === 'error'
                        ? t(CommonMessages.error())
                        : selectedShowToast?.errorType === 'success'
                        ? t(CommonMessages.success())
                        : selectedShowToast?.errorType === 'warning'
                        ? t(CommonMessages.warning())
                        : selectedShowToast?.errorType === 'info'
                        ? t(CommonMessages.info())
                        : ''}
                    </span>
                    <span className="message">
                      {selectedShowToast?.errorTxt}
                    </span>
                  </div>
                </ContentWarpper>
              </Notification>
            </Fade>
          </NotificationGroup>
        </Wrapper>
      )}
    </>
  );
};

const ContentWarpper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  font-family: 'Open Sans';
  img {
    width: 22px;
    height: 22px;
    margin: 0 8px 0 0;
  }
  .title-wrapper {
    display: flex;
    flex-direction: column;
    .title {
      font-size: 14px;
      font-weight: 600;
    }
    .message {
      font-size: 12px;
      font-weight: 400;
    }
  }
`;
export const Wrapper = styled.div`
  .k-notification-group {
    font-family: 'Open Sans';
    animation-name: example;
    animation-duration: 1s;
  }
  @keyframes example {
    0% {
      right: -500px;
    }
    100% {
      right: 0px;
    }
  }
  &.change-width {
    .k-notification {
      max-width: 450px !important;
    }
  }
  .k-notification {
    display: flex;
    align-items: center;
    max-width: 281px;
    max-width: 350px;
    width: 100%;
    justify-content: space-between;
    gap: 8px;

    .k-i-x::before {
      cursor: pointer;
      content: url(${closeIcon});
    }
  }
  .k-notification-error {
    background-color: ${p => p.theme.errorBgClr};
    border-color: ${p => p.theme.errorBgClr};
    color: ${p => p.theme.black};
    font-weight: 500;
    font-family: 'Open Sans';
    padding: 2px 22px;
    border-bottom: 4px solid ${p => p.theme.errorBrdrClr};
  }
  .k-notification-success {
    background-color: ${p => p.theme.successBgClr};
    border-color: ${p => p.theme.successBgClr};
    color: ${p => p.theme.black};
    font-weight: 500;
    font-family: 'Open Sans';
    padding: 2px 22px;
    border-bottom: 4px solid ${p => p.theme.successBrdrClr};
  }
  .k-notification-warning {
    background-color: ${p => p.theme.warningBgClr};
    border-color: ${p => p.theme.warningBgClr};
    color: ${p => p.theme.black};
    font-weight: 500;
    font-family: 'Open Sans';
    padding: 2px 22px;
    border-bottom: 4px solid ${p => p.theme.warningBrdrClr};
  }
  .k-notification-info {
    background-color: ${p => p.theme.infoBgClr};
    border-color: ${p => p.theme.infoBgClr};
    color: ${p => p.theme.black};
    font-weight: 500;
    font-family: 'Open Sans';
    padding: 2px 22px;
    border-bottom: 4px solid ${p => p.theme.infoBrdrClr};
  }

  .k-notification .k-icon.k-i-x-outline.k-notification-status {
    width: 20px;
    height: 20px;
    display: inline-flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
  }
`;
